import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class AffiliateConfig extends Component {
  render() {
    const {
      children,
      domElement,
      has,
      ifNot,
      className,
      affiliateConfig,
    } = this.props;

    let node = null;
    const elementProps = {};

    if (_.get(affiliateConfig, has) === 'true') {
      if (children.length !== undefined) {
        elementProps.className = className;
        node = React.createElement(domElement, elementProps, children);
      } else {
        node = children;
      }
    } else if (ifNot) {
      if (ifNot.length !== undefined) {
        node = React.createElement(domElement, elementProps, ifNot);
      } else {
        node = ifNot;
      }
    }
    return node;
  }
}

AffiliateConfig.propTypes = {
  has: PropTypes.string,
  domElement: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
  affiliateConfig: PropTypes.objectOf(PropTypes.string),
  ifNot: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
};

AffiliateConfig.defaultProps = {
  has: '--NOT-SET--',
  domElement: 'div',
  className: '',
  ifNot: null,
};

const mapStateToProps = ({ session: { affiliate: { attributes: { config } } } }) => ({
  config,
});

export default connect(mapStateToProps)(AffiliateConfig);



// WEBPACK FOOTER //
// ./src/containers/AffiliateConfig.js